<template>
  <div>
    <Loading v-if="loading" />
    <!-- My Tickets -->
    <div class="statuses">
      <div v-for="status in ticket_statuses" :key="status.id" class="status">
        <h4 style="margin: 0">
          {{ status.label }} ({{ status.tickets ? status.tickets.length : 0 }})
        </h4>
        <div class="tickets">
          <div
            v-for="ticket in status.tickets"
            :key="ticket.id"
            class="ticket cards"
          >
            <div class="card" @click="selectTicket(ticket.id)">
              {{ ticket.properties.subject }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      loading: null,
      ticket_statuses: null,
    };
  },

  methods: {
    getTickets: async function() {
      try {
        this.loading = true;
        const response = await this.$axios({
          method: "get",
          url: "https://env4lrmgz7v5bcu.m.pipedream.net",
          params: {
            contact_id: this.apidata.me.id,
            pipeline_id: this.apidata.system.ticket_pipeline_id,
          },
        });

        this.ticket_statuses = response.data.ticket_statuses;
      } catch (error) {
        this.$toast.error(error.message);
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    selectTicket: async function(ticket_id) {
      const routeData = this.$router.resolve(`/tickets/${ticket_id}`);
      window.open(routeData.href, "_blank");
    },
  },

  created: async function() {
    await this.getTickets();
  },
};
</script>

<style scoped>
.statuses {
  display: flex;
}

.status {
  width: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-right: 1px solid lightgrey;
  padding: 10px;
  overflow: auto;
  text-align: center;
}

.status h4 {
  font-size: 12.5px;
}

.status:first-child {
  border-left: 1px solid lightgrey;
}

.tickets {
  height: 600px;
  margin-top: 20px;
  width: 100%;
}

.contact {
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
  margin-bottom: 25px;
  border-bottom: 1px solid rgb(201, 201, 201);
  align-items: center;
  margin-right: 20px;
}

.contact h4 {
  color: var(--primary-color);
}

.contact div {
  margin-bottom: 5px;
}

.contact .left {
  margin-right: 10px;
}

.contacts {
  max-height: 400px;
  overflow: auto;
}

.ticket-info:not(:first-child) {
  border-left: 4px solid var(--primary-color);
  padding-left: 5px;
  margin-top: 5px;
}

.mini-label {
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 12px;
  color: grey;
}

.mini-label:not(:first-child) {
  margin-top: 20px;
}

input[type="checkbox"] {
  transform: scale(1.5);
}
</style>
